import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EnderecoPessoa } from 'src/app/shared/models/pessoa.model';

@Component({
  selector: 'app-endereco-cliente',
  templateUrl: './endereco-cliente.component.html',
  styleUrls: ['./endereco-cliente.component.css']
})
export class EnderecoClienteComponent implements OnInit {
  @Input() public endereco: EnderecoPessoa;
  @Output() public enderecoGravado = new EventEmitter<EnderecoPessoa>();
  
  constructor() { }
  
  ngOnInit() {
  }

  GravarEndereco() {
    this.enderecoGravado.emit(this.endereco);
  }

}
